// Module-scoped promise cache so each provider's embed script loads
// exactly once per page no matter how many embeds use it. Subsequent
// calls return the same promise.

const loaded = new Map<string, Promise<void>>()

export function loadEmbedScript(src: string): Promise<void> {
  if (typeof window === 'undefined') return Promise.resolve()
  const existing = loaded.get(src)
  if (existing) return existing

  const promise = new Promise<void>((resolve, reject) => {
    // Pre-existing tag (e.g. another embed component or a previous client
    // navigation that didn't clear the cache) — reuse it.
    const present = document.querySelector<HTMLScriptElement>(
      `script[data-embed-loader="${src}"]`,
    )
    if (present) {
      if (present.dataset.loaded === 'true') {
        resolve()
        return
      }
      present.addEventListener('load', () => resolve(), { once: true })
      present.addEventListener('error', () => reject(new Error(`Failed: ${src}`)), { once: true })
      return
    }
    const tag = document.createElement('script')
    tag.src = src
    tag.async = true
    tag.dataset.embedLoader = src
    tag.addEventListener(
      'load',
      () => {
        tag.dataset.loaded = 'true'
        resolve()
      },
      { once: true },
    )
    tag.addEventListener('error', () => reject(new Error(`Failed: ${src}`)), { once: true })
    document.body.appendChild(tag)
  })

  loaded.set(src, promise)
  return promise
}
